import { Link } from 'react-router-dom';

export default function AboutPreview() {
  return (
    <section className="py-24 bg-gradient-to-b from-deep-black to-forest-green/20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="bg-forest-green rounded-3xl p-12 lg:p-16 relative overflow-hidden">
          {/* Decorative Element */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-copper/5 rounded-full blur-3xl"></div>
          
          <div className="relative">
            {/* Accent Line */}
            <div className="w-16 h-0.5 bg-copper mb-8"></div>

            {/* Heading */}
            <h2 className="font-serif text-4xl lg:text-5xl text-white mb-8">
              Committed to Quality & Service
            </h2>

            {/* Content */}
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>
                At High Standards Smoke Shop, we believe that every customer deserves access to premium products and exceptional service. Located in the heart of Eustis, Florida, we've built our reputation on quality, authenticity, and expertise.
              </p>
              <p>
                Our carefully curated selection features the finest vapes, hand-crafted glass pieces, traditional hookah setups, and premium accessories.&nbsp;
              </p>
              <p>
                We pride ourselves on creating a welcoming, sophisticated atmosphere where quality meets affordability. Visit us today and experience the High Standards difference.
              </p>
            </div>

            {/* CTA */}
            <Link
              to="/about"
              className="inline-flex items-center gap-2 mt-8 text-copper font-medium hover:gap-4 transition-all duration-300 cursor-pointer group"
            >
              <span>Learn More About Us</span>
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
